/**
 * @desc formSubmit
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.ApprovalRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/approval/formSubmit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
